module.exports = __webpack_public_path__ + "media/01.f7af73ec.mp3";